import type { OptionLabelPair } from '../../../../components/RadioGroup';
import type { BooleanFlag } from '../../../../types/boolean-flag';
import { BOOLEAN_FLAGS } from '../../../../types/boolean-flag';

export const AUTOMATICALLY_IMPORT_CUSTOMERS_OPTIONS: OptionLabelPair<BooleanFlag>[] = [
  { value: BOOLEAN_FLAGS.ENABLED, label: 'Automatically import customers from HubSpot (recommended)' },
  { value: BOOLEAN_FLAGS.DISABLED, label: 'Do not import automatically' },
];

export const AUTOMATICALLY_IMPORT_CONTRACTS_OPTIONS: OptionLabelPair<BooleanFlag>[] = [
  { value: BOOLEAN_FLAGS.ENABLED, label: 'Automatically import contracts from HubSpot (recommended)' },
  { value: BOOLEAN_FLAGS.DISABLED, label: 'Do not import automatically' },
];
